import * as React from 'react';
import { billExample } from '@/constants/constants';

// helpers
import {
	checkDatasetForWarnings,
	checkDatasetForErrors,
	checkEnterData,
	validateVisualEditorData,
} from '@/helpers/check-dataset';
import { getPaymentInfoDataset } from '@/helpers/get-payment-info-dataset';

// components
import Json from './Json';
import DieManager from './DieManager';
import VisualEditor from './VisualEditor';
import Error from '@/components/InputForm/Error';

import letterMeta from '@/service/letter-meta';
import styles from './InputForm.css';
import TEXTS from '@/constants/texts';

interface InputFormProps {}

interface InputFormState {
	isCorrectlyWrapperData: boolean,
	paymentInfo: EnteredPaymentInfo | null,
	errorMessages: string[] | null,
	warningMessages: string[] | null,
	billJsObject: PaymentInfo,
	isBillEntered: boolean,
	enterType: number,
	amount: string | null,
	period: string | null,
	payer: string | null,
	address: string | null,
}

class InputForm extends React.Component<InputFormProps, InputFormState> {
	public constructor(props: InputFormProps) {
		super(props);

		this.state = {
			isCorrectlyWrapperData: false,
			paymentInfo: {
				amount: '400.5',
				period: 'Октябрь 2018',
				payer: 'Федорова В.В.',
				address: 'Алтайский край, г. Барнаул, Солнечная поляна, д.43, к.72',
			},
			errorMessages: [],
			warningMessages: [],
			billJsObject: billExample,
			isBillEntered: false,

			enterType: 0,

			amount: null,
			period: null,
			payer: null,
			address: null,
		};
	}

	public componentDidMount(): void {
		const { paymentInfo } = this.state;
		letterMeta(paymentInfo);
	}

	public setAmount = (e: React.ChangeEvent<HTMLInputElement>): void => {
		this.setState({ amount: e.target.value });
	};

	public setPeriod = (e: React.ChangeEvent<HTMLInputElement>): void => {
		this.setState({ period: e.target.value });
	};

	public setPayer = (e: React.ChangeEvent<HTMLInputElement>): void => {
		this.setState({ payer: e.target.value });
	};

	public setAddress = (e: React.ChangeEvent<HTMLInputElement>): void => {
		this.setState({ address: e.target.value });
	};

	public onRefreshClick = (): void => {
		const { amount, period, payer, address, enterType } = this.state;

		if (enterType === 0) {
			this.onChangeWrapper();
		} else {
			this.setState({
				paymentInfo: {
					period,
					amount,
					payer,
					address,
				},
				isCorrectlyWrapperData: checkEnterData(amount),
				errorMessages: validateVisualEditorData(amount),
			});
		}
	};

	public handleChangeJsonEditorValue = ({ jsObject }: { jsObject: PaymentInfo }): void => {
		if (jsObject) {
			const { totalPaymentDue, customer, billingPeriod } = jsObject;
			this.setState({
				billJsObject: jsObject,
				isBillEntered: true,

				amount: totalPaymentDue ? totalPaymentDue.price : null,
				period: billingPeriod,
				payer: customer ? customer.name : null,
				address: customer ? customer.address : null,
			});
		} else {
			this.setState({
				billJsObject: jsObject,
				isBillEntered: true,
			});
		}
	};

	private onChangeWrapper = (): void => {
		const { isBillEntered, billJsObject } = this.state;

		// TODO: зачем проверять, если это billExample
		const errorMessages = checkDatasetForErrors(billJsObject);
		const warningMessages = checkDatasetForWarnings(billJsObject);
		const paymentInfo = getPaymentInfoDataset(isBillEntered, billJsObject);

		this.setState({
			isCorrectlyWrapperData: errorMessages ? errorMessages.length === 0 : true,
			errorMessages,
			warningMessages,
			paymentInfo,
		});
	};

	private selectEnterType = (enterType: number): void => {
		const activeElement: HTMLElement | null = document.querySelector(`[data-id="select:${enterType}"]`);
		if (activeElement) {
			activeElement.className = styles.activeSelect;
		}

		const inactiveElement: HTMLElement | null = document.querySelector(`[data-id="select:${Number(!enterType)}"]`);
		if (inactiveElement) {
			inactiveElement.className = styles.inactiveSelect;
		}

		this.setState({
			enterType,
			amount: null,
			period: null,
			payer: null,
			address: null,
		});
	};

	public render(): JSX.Element {
		const {
			isCorrectlyWrapperData,
			paymentInfo,
			errorMessages,
			warningMessages,
			isBillEntered,
			billJsObject,
			enterType,
		} = this.state;

		const placeholder = isBillEntered ? billJsObject : billExample;

		return (
			<div className={styles.enterContainer} id="input-form">
				<div className={styles.textBlock}>
					<p className={styles.inputFormTitle}>{TEXTS.inputFormTitle}</p>
				</div>

				<div className={styles.selectBlock}>
					<div
						data-id="select:0"
						className={styles.activeSelect}
						onClick={() => this.selectEnterType(0)}
					>
						{TEXTS.inputFormSelectBlockFirstTitle}
					</div>
					<div
						data-id="select:1"
						className={styles.inactiveSelect}
						onClick={() => this.selectEnterType(1)}
					>
						{TEXTS.inputFormSelectBlockSecondTitle}
					</div>
				</div>

				<div className={styles.dieBlock}>
					<div className={styles.editorBlock}>
						{enterType === 0 && (
							<Json
								handleChangeJsonEditorValue={this.handleChangeJsonEditorValue}
								placeholder={placeholder}
							/>
						)}

						{enterType === 1 && (
							<VisualEditor
								setAmount={this.setAmount}
								setPeriod={this.setPeriod}
								setAddress={this.setAddress}
								setPayer={this.setPayer}
							/>
						)}

						<Error
							warningMessages={warningMessages}
							errorMessages={errorMessages}
						/>
					</div>

					<div className={styles.dieContainer}>
						<img
							src="https://img.imgsmail.ru/static.promo/jsonld-demo/messages_list.png"
							className={styles.dieImage}
						/>
						<div className={styles.wrapperContainer} id="container">
							<DieManager
								isDataCorrect={isCorrectlyWrapperData}
								paymentInfo={paymentInfo}
							/>
						</div>
					</div>
				</div>

				<div className={styles.buttonContainer}>
					<div className={styles.button} onClick={this.onRefreshClick}>
						<p className={styles.buttonText}>Обновить</p>
					</div>
				</div>
			</div>
		);
	}
}

export default InputForm;
